import { z } from 'zod';
import { routeModifierSchema } from './route-modifier.schema';

export const routeModifierPagedCollectionSchema = z.object({
  href: z.string().nullable(),
  offset: z.number(),
  limit: z.number(),
  size: z.number(),
  data: z.array(routeModifierSchema),
});
